import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./routes/App.tsx";
import { initAnalytics } from "./lib/analytics/ga4";
import { installGlobalErrorHandlers } from "./lib/analytics/track";
import { installAutoClickTracking } from "./lib/analytics/autoClick";
import * as Sentry from "@sentry/react";
import { ErrorPage } from "./Pages/Error.tsx";
import { initSentry } from "./lib/sentry/index.ts";
import { initDevice } from "./lib/device";

// Initialize analytics once on startup (safe no-op if VITE_GA_MEASUREMENT_ID is not set).
initAnalytics();
installGlobalErrorHandlers();
installAutoClickTracking();
initSentry();
void initDevice(); // fire-and-forget; never blocks render

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorPage />} showDialog>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
